export default __webpack_public_path__ + "static/media/pump.1ea1da73.png";